import React, { Component } from "react";
import { ReactComponent as ImageIcon } from "../../../../assets/svg/camera-dark-color.svg";
import ImageAnalysticsModal from "./ImageAnalyticsModal";
import "./ImageAnalyticsFooter.scss";

class ImageAnalyticsFooter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            imageInfoModalOpen: false,
        };
    }
    // imageInfoModalShowSet = (imageInfoModalOpen) => {
    //     this.setState({ imageInfoModalOpen });
    // };
    showImageInfo = () => {
        this.imageInfoModalShowSet(true);
        //this.props.fetchPostInfo(this.props.data.postId);
    };
    imageInfoModalShowSet = (imageInfoModalOpen) => {
        this.setState({ imageInfoModalOpen });
    };
    render() {
        return (
            <>
                <div className="image-post-footer skiptranslate" onClick={this.showImageInfo}>
                    <ImageIcon className="camera-icon" />

                    {Object.keys(this.props.data.imageAnalystics).map((rdata_platformValue, index) => (
                        <div className="image-footer-items" key={index}>
                            {rdata_platformValue === "Logos" && (
                                <span>
                                    {rdata_platformValue} -{" "}
                                    <span className="logoColor"> {Object.keys(this.props.data.imageAnalystics[rdata_platformValue]).length} </span>{" "}
                                </span>
                            )}

                            {rdata_platformValue === "Objects" && (
                                <span>
                                    {rdata_platformValue} -{" "}
                                    <span className="objectColor"> {Object.keys(this.props.data.imageAnalystics[rdata_platformValue]).length} </span>{" "}
                                </span>
                            )}

                            {rdata_platformValue === "Scenes" && (
                                <span>
                                    {rdata_platformValue} - <span> {Object.keys(this.props.data.imageAnalystics[rdata_platformValue]).length} </span>{" "}
                                </span>
                            )}

                            {rdata_platformValue === "Text in Images" && (
                                <span>
                                    {"Texts"} - <span className="ocrColor"> {Object.keys(this.props.data.imageAnalystics[rdata_platformValue]).length} </span>{" "}
                                </span>
                            )}
                        </div>
                    ))}
                </div>
                <ImageAnalysticsModal
                    data={this.props.data.imageAnalystics}
                    postImage={this.props.data.postImg}
                    postText={this.props.data.post}
                    // apiStatus={this.props.postInfoStatus}
                    open={this.state.imageInfoModalOpen}
                    hideModal={() => this.imageInfoModalShowSet(false)}
                    // platformName={this.props.data.platformName}
                    //  isTrial={this.props.isTrial}
                />
            </>
        );
    }
}

export default ImageAnalyticsFooter;
